<template>
  <div :style="{ 'width': clientWidth + 'px', 'height': clientHeight + 'px' }" class="login">
    <div class="layer">
      <div class="content">
        <div class="logo"><img src="../../assets/login_logo.png" width="227" height="62" alt=""></div>
        <div class="int">
          <el-input type="text" class="phone" v-model="manager_name" placeholder="请输入账号"/>
        </div>
        <div class="int password">
          <el-input type="password" @keyup.enter.native="login" class="password" v-model="manager_password"
                    placeholder="请输入密码"/>
        </div>
        <div @click="login" class="click">立即登录</div>
        <div class="Txt">
          <router-link tag="span" to="/ForgetPassword">忘记密码？</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        clientWidth: '',
        clientHeight: '',
        manager_name: '',
        manager_password: ''
      }
    },
    mounted () {
      this.clientWidth = document.documentElement.clientWidth
      this.clientHeight = document.documentElement.clientHeight
      window.onresize = function () {
        this.clientWidth = document.documentElement.clientWidth
        this.clientHeight = document.documentElement.clientHeight
      }
    },
    created () {

    },
    methods: {
      login () {
        const that = this
        if (this.manager_name === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请输入账号'
          })
          return false
        }
        if (this.manager_password === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请输入密码'
          })
          return false
        }
        this.$http.post('/apipx/User/pxlogin', {
          manager_name: this.manager_name,
          manager_password: this.manager_password
        }).then(res => {
          if (res.code === 0) {
            localStorage.setItem('login', JSON.stringify(res.data))
            that.$router.replace('/')
            that.$message({
              message: res.msg,
              type: 'success',
              duration: 2000
            })
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .login {
    background: url("bg.png") no-repeat center center;

    .layer {
      width: 993px;
      height: 500px;
      position: fixed;
      background: url("layer.png") no-repeat center center;
      left: 50%;
      top: 50%;
      margin: -250px 0px 0px -496.5px;

      .content {
        width: 300px;
        overflow: hidden;
        margin-left: 530px;

        .logo {
          width: 227px;
          height: 62px;
          margin: 95px auto 35px;
        }

        .int {
          width: 300px;
          height: 44px;
          margin: 10px auto 0;

          .phone {
            input {
              background: url("phone.png") no-repeat 3% 50%;
              background-size: 35px 35px;
            }
          }

          .password {
            input {
              background: url("password.png") no-repeat 3% 50%;
              background-size: 35px 35px;
            }
          }

          input {
            width: 298px;
            height: 42px;
            border: 1px solid #c6c6c6;
            color: #c6c6c6;
            line-height: 42px;
            padding: 0;
            text-indent: 40px;
          }
        }

        .click {
          width: 300px;
          height: 45px;
          background-color: #ff8484;
          text-align: center;
          line-height: 45px;
          color: #fff;
          border-radius: 10px;
          cursor: pointer;
          margin: 36px auto 0;

          &:hover {
            background-color: #fc9797;
          }

          &:active {
            width: 298px;
            height: 43px;
            border: 1px solid #ff8484;
          }
        }

        .Txt {
          width: 300px;
          text-align: right;
          color: #ff8484;
          margin: 10px auto 0;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue